import { Spin } from 'antd';
export { Spin as default } from 'antd';
import React__default from 'react';
import LoadingOutlined from '../node_modules/.pnpm/@ant-design_icons@5.6.1_react-dom@18.3.1_react@18.3.1/node_modules/@ant-design/icons/es/icons/LoadingOutlined.js';

// import { LoadingOutlined } from '../pebble-icons';

var antIcon = /*#__PURE__*/React__default.createElement(LoadingOutlined, null);
Spin.setDefaultIndicator(antIcon);
